import { Typography } from "@material-ui/core";
import useStyles from "./style";

export const DashboardHeader = () => {
    const styles = useStyles();
    return (
        <div className={styles.root}>
            {/*
                <Typography variant='h3'>
                    NARAKUTA STUDIO
                </Typography>
              */
            }
        </div>
    );
};
